"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Component_1 = __importDefault(require("../Component"));
class SidebarButtonComponent extends Component_1.default {
    constructor(text, iconTemplate = '', isActive) {
        super();
        this.text = text;
        this.iconTemplate = iconTemplate;
        this.isActive = isActive;
    }
    getTemplate() {
        return `
      <li class="aside__item">
        <button class="aside__btn aside__tabs-btn ${this.isActive ? 'aside__btn-active' : ''}" data-path="tracks">
        ${this.iconTemplate}
      <span>${this.text}</span>
        </button>
      </li>
    `;
    }
    addOnClickListener(callback) {
        const button = this.getElement().querySelector('.aside__btn');
        if (button) {
            button.addEventListener('click', callback);
        }
    }
}
exports.default = SidebarButtonComponent;
